<template>
  <div>
    <div class="mt-5 mb-2">
      <v-label>{{ this.label }}</v-label>
    </div>
    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      @click="openFileDialog"
      :class="{ 'grey lighten-2': dragover }"
    >
      <v-file-input
        ref="fileInput"
        v-model="selectedFiles"
        :multiple="multiple"
        :accept="acceptedExtensions.join(',')"
        @change="uploadFiles()"
        v-show="false"
      ></v-file-input>
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon :class="[dragover ? 'mt-2 mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
          <p>{{ $t('fileUploader.message') }}</p>
        </v-row>
        <v-virtual-scroll v-if="uploadedFiles.length > 0" :items="uploadedFiles" height="150" item-height="50">
          <template v-slot:default="{ item }">
            <v-list-item :key="item.name">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <span class="ml-3 text--secondary"> {{ formatFileSize(item.size) }}</span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn @click.stop="removeFile(item.name)" icon>
                  <v-icon> mdi-close-circle </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </v-card>
    <v-input :value="uploadedFiles" :rules="ruleFile"> </v-input>
  </div>
</template>

<script>
export default {
  name: "FileUploader",
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    minRequired: {
      type: Number,
      default: 0,
    },
    extensions: {
      type: Array,
      default: () => [],
    },
    rule: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dragover: false,
      // liste des fichiers validé par le composant
      uploadedFiles: [],
      // contient les fichiers dans le cas d'une selection via la modal classic
      selectedFiles: [],
      errorMessage: null,
      defaultAcceptedExtensions: [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv", ".jpg", ".jpeg", ".png"],
      rules: {
        justificatifs: [
          (v) => v.length || (this.minRequired > 1
              ? this.$t('fileUploader.nDocumentRequired', { minRequired: this.minRequired })
              : this.$t('fileUploader.documentRequired')),
        ],
      },
    }
  },
  computed: {
    acceptedExtensions() {
      return this.extensions.length > 0 ? this.extensions : this.defaultAcceptedExtensions
    },
    ruleFile() {
      return this.rule.length > 0 ? this.rule : this.rules.justificatifs
    },
  },
  methods: {
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName)

      if (index > -1) {
        this.uploadedFiles.splice(index, 1)
      }
      this.submit()
    },
    onDrop(e) {
      this.dragover = false

      // Si défini sur non multiple
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        alert(this.$t('fileUploader.multipleDisabled'))
      } else {
        if (this.checkExtensions(e.dataTransfer.files)) {
          Array.from(e.dataTransfer.files).forEach((element) => this.uploadedFiles.push(element))
          this.submit()
        }
      }
    },
    checkExtensions(files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileNameParts = file.name.split(".")
        const fileExtension = `.${fileNameParts[fileNameParts.length - 1]}`
        if (!this.acceptedExtensions.includes(fileExtension)) {
          alert(this.$t('fileUploader.invalidExtension', { name: file.name }))
          return false
        }
      }
      return true
    },
    submit() {
      this.$emit("filesUploaded", this.uploadedFiles)
    },
    formatFileSize(size) {
      const units = ["B", "KB", "MB", "GB", "TB"]
      let i = 0
      while (size >= 1024 && i < units.length - 1) {
        size /= 1024
        i++
      }
      return `${Math.round(size)} ${units[i]}`
    },

    openFileDialog() {
      this.$refs.fileInput.$refs.input.click()
    },
    uploadFiles() {
      Array.from(this.selectedFiles).forEach((element) => this.uploadedFiles.push(element))
      this.selectedFiles = []
      this.submit()
    },
    clearFiles() {
      this.selectedFiles = []
      this.uploadedFiles = []
    },
  },
}
</script>
